import React, { useState, useEffect } from 'react';
import { Search, Plus, Edit, Trash2, User, Calendar, School, Phone, Mail, Eye, EyeOff, MapPin, FileText, Save, X, UserPlus, Lock, Upload } from 'lucide-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import alunosService from '../services/alunosService';
import { getCurrentUserProfile } from '../services/usuariosService';
import ImportarAlunos from './ImportarAlunos';
import '../styles/alunos.css';

const Alunos = () => {
  // Estados principais
  const [alunos, setAlunos] = useState([]);
  const [escolas, setEscolas] = useState([]);
  const [anosEscolares, setAnosEscolares] = useState([]);
  const [currentUserProfile, setCurrentUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Estados de filtros
  const [searchTerm, setSearchTerm] = useState('');
  const [filterEscola, setFilterEscola] = useState('');
  const [filterAno, setFilterAno] = useState('');
  const [filterPeriodo, setFilterPeriodo] = useState('');
  
  // Estados do modal
  const [showModal, setShowModal] = useState(false);
  const [editingAluno, setEditingAluno] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  
  // Estado do formulário
  const [formData, setFormData] = useState({
    cpf: '',
    nome: '',
    escola_id: '',
    ano_escolar_id: '',
    periodo: '',
    email: '',
    telefone: '',
    sexo: '',
    data_nascimento: '',
    ra: '',
    senha: '',
    confirmarSenha: '',
    logradouro: '',
    numero: '',
    bairro: '',
    cidade: '',
    estado: '',
    complemento: '',
    observacoes: '',
    ativo: true
  });
  
  const [errors, setErrors] = useState({});
  const [createAuthUser, setCreateAuthUser] = useState(false);

  // Constantes
  const estadosBrasileiros = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
    'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
    'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
  ];

  const periodos = ['manhã', 'tarde', 'noite'];
  const sexos = ['masculino', 'feminino', 'outro'];

  // Carregar dados iniciais
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      // Carregar perfil do usuário logado
      const profileResult = await getCurrentUserProfile();
      console.log('🔍 [Alunos] Profile Result:', profileResult);
      
      if (profileResult.success) {
        setCurrentUserProfile(profileResult.data);
        console.log('🔍 [Alunos] Profile Data:', profileResult.data);
        console.log('🔍 [Alunos] school_adm:', profileResult.data?.school_adm);
        console.log('🔍 [Alunos] school_id:', profileResult.data?.school_id);
      }

      // Carregar dados básicos
      const [alunosData, escolasData, anosData] = await Promise.all([
        alunosService.getAll(),
        alunosService.getEscolas(),
        alunosService.getAnosEscolares()
      ]);
      
      console.log('🔍 [Alunos] Escolas carregadas:', escolasData);
      
      setAlunos(alunosData);
      setAnosEscolares(anosData);
      
      // Filtrar escolas baseado no perfil do usuário (igual ao Usuarios.js)
      if (profileResult.success && profileResult.data?.school_adm && profileResult.data?.school_id) {
        console.log('🔍 [Alunos] Filtrando escola para school admin');
        const escolaDoUsuario = escolasData.filter(escola => escola.id === profileResult.data.school_id);
        console.log('🔍 [Alunos] Escola filtrada:', escolaDoUsuario);
        setEscolas(escolaDoUsuario);
      } else {
        console.log('🔍 [Alunos] Usando todas as escolas (super admin)');
        setEscolas(escolasData);
      }
      
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      alert('Erro ao carregar dados. Verifique sua conexão.');
    } finally {
      setLoading(false);
    }
  };

  // Filtrar alunos
  const filteredAlunos = alunos.filter(aluno => {
    const matchesSearch = !searchTerm || 
      aluno.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
      aluno.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      aluno.cpf.includes(searchTerm);
    
    // Se for school admin, filtrar apenas alunos da escola do usuário
    let matchesEscola = true;
    if (currentUserProfile?.school_adm && currentUserProfile?.school_id) {
      matchesEscola = aluno.escola_id === currentUserProfile.school_id;
    } else if (filterEscola) {
      matchesEscola = aluno.escola_id === filterEscola;
    }
    
    const matchesAno = !filterAno || aluno.ano_escolar_id === filterAno;
    const matchesPeriodo = !filterPeriodo || aluno.periodo === filterPeriodo;
    
    return matchesSearch && matchesEscola && matchesAno && matchesPeriodo;
  });

  // Abrir modal para criar/editar
  const openModal = (aluno = null) => {
    if (aluno) {
      setEditingAluno(aluno);
      setFormData({
        cpf: aluno.cpf || '',
        nome: aluno.nome || '',
        escola_id: aluno.escola_id || '',
        ano_escolar_id: aluno.ano_escolar_id || '',
        periodo: aluno.periodo || '',
        email: aluno.email || '',
        telefone: aluno.telefone || '',
        sexo: aluno.sexo || '',
        data_nascimento: aluno.data_nascimento || '',
        ra: aluno.ra || '',
        senha: '',
        confirmarSenha: '',
        logradouro: aluno.logradouro || '',
        numero: aluno.numero || '',
        bairro: aluno.bairro || '',
        cidade: aluno.cidade || '',
        estado: aluno.estado || '',
        complemento: aluno.complemento || '',
        observacoes: aluno.observacoes || '',
        ativo: aluno.ativo !== undefined ? aluno.ativo : true
      });
      setCreateAuthUser(false);
    } else {
      setEditingAluno(null);
      setFormData({
        cpf: '',
        nome: '',
        escola_id: currentUserProfile?.school_adm ? currentUserProfile.school_id : '',
        ano_escolar_id: '',
        periodo: '',
        email: '',
        telefone: '',
        sexo: '',
        data_nascimento: '',
        ra: '',
        senha: '',
        confirmarSenha: '',
        logradouro: '',
        numero: '',
        bairro: '',
        cidade: '',
        estado: '',
        complemento: '',
        observacoes: '',
        ativo: true
      });
      setCreateAuthUser(true);
    }
    setErrors({});
    setShowModal(true);
  };

  // Fechar modal
  const closeModal = () => {
    setShowModal(false);
    setEditingAluno(null);
    setFormData({});
    setErrors({});
    setShowPassword(false);
    setShowConfirmPassword(false);
  };

  // Validar formulário
  const validateForm = () => {
    const newErrors = {};

    if (!formData.cpf) newErrors.cpf = 'CPF é obrigatório';
    if (!formData.nome) newErrors.nome = 'Nome é obrigatório';
    if (!formData.email) newErrors.email = 'Email é obrigatório';
    if (!formData.escola_id) newErrors.escola_id = 'Escola é obrigatória';
    if (!formData.ano_escolar_id) newErrors.ano_escolar_id = 'Ano escolar é obrigatório';
    if (!formData.periodo) newErrors.periodo = 'Período é obrigatório';
    
    if (!editingAluno) {
      if (!formData.senha) newErrors.senha = 'Senha é obrigatória';
      if (formData.senha !== formData.confirmarSenha) {
        newErrors.confirmarSenha = 'Senhas não coincidem';
      }
    } else if (formData.senha && formData.senha !== formData.confirmarSenha) {
      newErrors.confirmarSenha = 'Senhas não coincidem';
    }

    // Validar email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      newErrors.email = 'Email inválido';
    }

    // Validar CPF (básico)
    if (formData.cpf && formData.cpf.replace(/\D/g, '').length !== 11) {
      newErrors.cpf = 'CPF deve ter 11 dígitos';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Salvar aluno
  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);
      
      // Preparar dados para salvar
      const dataToSave = { ...formData };
      delete dataToSave.confirmarSenha;
      
      // Se não há senha, remover do objeto
      if (!dataToSave.senha) {
        delete dataToSave.senha;
      }

      let savedAluno;
      
      if (editingAluno) {
        // Atualizar aluno existente
        savedAluno = await alunosService.update(editingAluno.id, dataToSave);
        setAlunos(prev => prev.map(a => a.id === editingAluno.id ? savedAluno : a));
      } else {
        // Criar novo aluno
        savedAluno = await alunosService.create(dataToSave);
        
        // Se deve criar usuário de autenticação
        if (createAuthUser) {
          try {
            await alunosService.createAuthUser(formData.email, formData.senha, {
              ...savedAluno,
              id: savedAluno.id
            });
          } catch (authError) {
            console.error('Erro ao criar usuário de autenticação:', authError);
            // Continua mesmo se falhar a criação do usuário auth
          }
        }
        
        setAlunos(prev => [...prev, savedAluno]);
      }
      
      closeModal();
      alert(editingAluno ? 'Aluno atualizado com sucesso!' : 'Aluno criado com sucesso!');
    } catch (error) {
      console.error('Erro ao salvar aluno:', error);
      
      if (error.message?.includes('duplicate key')) {
        if (error.message.includes('cpf')) {
          setErrors({ cpf: 'Este CPF já está cadastrado' });
        } else if (error.message.includes('email')) {
          setErrors({ email: 'Este email já está cadastrado' });
        }
      } else {
        alert('Erro ao salvar aluno. Verifique os dados e tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  // Excluir aluno
  const handleDelete = async (aluno) => {
    if (!window.confirm(`Tem certeza que deseja excluir o aluno ${aluno.nome}?`)) {
      return;
    }

    try {
      setLoading(true);
      await alunosService.delete(aluno.id);
      setAlunos(prev => prev.filter(a => a.id !== aluno.id));
      alert('Aluno excluído com sucesso!');
    } catch (error) {
      console.error('Erro ao excluir aluno:', error);
      alert('Erro ao excluir aluno.');
    } finally {
      setLoading(false);
    }
  };

  // Alternar status ativo/inativo
  const toggleActive = async (aluno) => {
    try {
      const newStatus = !aluno.ativo;
      await alunosService.toggleActive(aluno.id, newStatus);
      setAlunos(prev => prev.map(a => a.id === aluno.id ? { ...a, ativo: newStatus } : a));
    } catch (error) {
      console.error('Erro ao alterar status:', error);
      alert('Erro ao alterar status do aluno.');
    }
  };

  // Formatação de CPF
  const formatCPF = (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');
  };

  // Formatação de telefone
  const formatPhone = (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4,5})(\d{4})/, '$1-$2');
  };

  // Handle input changes
  const handleInputChange = (field, value) => {
    if (field === 'cpf') {
      value = formatCPF(value);
    } else if (field === 'telefone') {
      value = formatPhone(value);
    }
    
    setFormData(prev => ({ ...prev, [field]: value }));
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  return (
    <div className="alunos-container">
      <div className="alunos-header">
        <div className="header-left">
          <h1>Gestão de Alunos</h1>
          <p>Gerencie os alunos cadastrados no sistema - Total: {filteredAlunos.length} alunos</p>
        </div>
        <div className="header-actions">
          <button 
            className="btn-secondary" 
            onClick={() => setShowImportModal(true)}
            disabled={loading}
          >
            <Upload size={20} />
            Importar Alunos
          </button>
          <button 
            className="btn-primary" 
            onClick={() => openModal()}
            disabled={loading}
          >
            <Plus size={20} />
            Novo Aluno
          </button>
        </div>
      </div>

      <div className="alunos-filters">
        <div className="filter-group">
          <div className="search-box">
            <Search size={20} />
            <input
              type="text"
              placeholder="Buscar por nome, email ou CPF..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        
        <div className="filter-row">
          {!currentUserProfile?.school_adm ? (
            <select value={filterEscola} onChange={(e) => setFilterEscola(e.target.value)}>
              <option value="">Todas as escolas</option>
              {escolas.map(escola => (
                <option key={escola.id} value={escola.id}>{escola.nome}</option>
              ))}
            </select>
          ) : null}
          
          <select value={filterAno} onChange={(e) => setFilterAno(e.target.value)}>
            <option value="">Todos os anos</option>
            {anosEscolares.map(ano => (
              <option key={ano.id} value={ano.id}>{ano.nome}</option>
            ))}
          </select>
          
          <select value={filterPeriodo} onChange={(e) => setFilterPeriodo(e.target.value)}>
            <option value="">Todos os períodos</option>
            {periodos.map(periodo => (
              <option key={periodo} value={periodo}>
                {periodo.charAt(0).toUpperCase() + periodo.slice(1)}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="alunos-grid">
        {filteredAlunos.map(aluno => (
          <div key={aluno.id} className={`aluno-card ${!aluno.ativo ? 'inactive' : ''}`}>
            <div className="aluno-header">
              <div className="aluno-avatar">
                {aluno.nome.charAt(0).toUpperCase()}
              </div>
              <h3 className="aluno-name">{aluno.nome}</h3>
              <p className="aluno-email">{aluno.email}</p>
            </div>
            
            <div className="aluno-info">
              <div className="info-item">
                <User size={16} />
                <span>{aluno.cpf}</span>
              </div>
              
              <div className="info-item">
                <School size={16} />
                <span>{aluno.escolas?.nome || 'N/A'}</span>
              </div>
              
              <div className="info-item">
                <Calendar size={16} />
                <span>{aluno.anos_escolares?.nome || 'N/A'} - {aluno.periodo}</span>
              </div>
              
              {aluno.telefone && (
                <div className="info-item">
                  <Phone size={16} />
                  <span>{aluno.telefone}</span>
                </div>
              )}
              
              <div className="info-item">
                <span className={`status-badge ${aluno.ativo ? 'active' : 'inactive'}`}>
                  {aluno.ativo ? 'Ativo' : 'Inativo'}
                </span>
              </div>
            </div>
            
            <div className="aluno-actions">
              <button 
                className="btn-action edit"
                onClick={() => openModal(aluno)}
              >
                <Edit size={16} />
                Editar
              </button>
              
              <button 
                className="btn-action toggle"
                onClick={() => toggleActive(aluno)}
              >
                {aluno.ativo ? 'Desativar' : 'Ativar'}
              </button>
              
              <button 
                className="btn-action delete"
                onClick={() => handleDelete(aluno)}
              >
                <Trash2 size={16} />
                Excluir
              </button>
            </div>
          </div>
        ))}
      </div>

      {filteredAlunos.length === 0 && !loading && (
        <div className="loading">
          {searchTerm || filterEscola || filterAno || filterPeriodo 
            ? 'Nenhum aluno encontrado com os filtros aplicados.' 
            : 'Nenhum aluno cadastrado.'}
        </div>
      )}

      {loading && alunos.length === 0 && (
        <div className="loading">Carregando...</div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingAluno ? 'Editar Aluno' : 'Novo Aluno'}</h2>
              <button className="btn-close" onClick={closeModal}>
                <X size={20} />
              </button>
            </div>
            
            <div className="modal-body">
              {/* Dados Pessoais */}
              <div className="form-section">
                <h3 className="section-title">Dados Pessoais</h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label required">CPF</label>
                    <input
                      type="text"
                      className={`form-input ${errors.cpf ? 'error' : ''}`}
                      value={formData.cpf}
                      onChange={(e) => handleInputChange('cpf', e.target.value)}
                      placeholder="000.000.000-00"
                      maxLength={14}
                    />
                    {errors.cpf && <div className="form-error">{errors.cpf}</div>}
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label required">Nome</label>
                    <input
                      type="text"
                      className={`form-input ${errors.nome ? 'error' : ''}`}
                      value={formData.nome}
                      onChange={(e) => handleInputChange('nome', e.target.value)}
                      placeholder="Nome completo"
                    />
                    {errors.nome && <div className="form-error">{errors.nome}</div>}
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label required">Email</label>
                    <input
                      type="email"
                      className={`form-input ${errors.email ? 'error' : ''}`}
                      value={formData.email}
                      onChange={(e) => handleInputChange('email', e.target.value)}
                      placeholder="email@exemplo.com"
                    />
                    {errors.email && <div className="form-error">{errors.email}</div>}
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label">Telefone</label>
                    <input
                      type="text"
                      className="form-input"
                      value={formData.telefone}
                      onChange={(e) => handleInputChange('telefone', e.target.value)}
                      placeholder="(00) 00000-0000"
                      maxLength={15}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label">Sexo</label>
                    <select
                      className="form-select"
                      value={formData.sexo}
                      onChange={(e) => handleInputChange('sexo', e.target.value)}
                    >
                      <option value="">Selecione</option>
                      {sexos.map(sexo => (
                        <option key={sexo} value={sexo}>
                          {sexo.charAt(0).toUpperCase() + sexo.slice(1)}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label">Data de Nascimento</label>
                    <input
                      type="date"
                      className="form-input"
                      value={formData.data_nascimento}
                      onChange={(e) => handleInputChange('data_nascimento', e.target.value)}
                    />
                  </div>
                </div>
              </div>
              
              {/* Dados Acadêmicos */}
              <div className="form-section">
                <h3 className="section-title">Dados Acadêmicos</h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label className="form-label required">Escola</label>
                    {currentUserProfile?.school_adm ? (
                      <input
                        type="text"
                        className="form-input disabled-input"
                        value={escolas.length > 0 ? escolas[0].nome : 'Escola não encontrada'}
                        disabled
                      />
                    ) : (
                      <select
                        className={`form-select ${errors.escola_id ? 'error' : ''}`}
                        value={formData.escola_id}
                        onChange={(e) => handleInputChange('escola_id', e.target.value)}
                      >
                        <option value="">Selecione uma escola</option>
                        {escolas.map(escola => (
                          <option key={escola.id} value={escola.id}>{escola.nome}</option>
                        ))}
                      </select>
                    )}
                    {errors.escola_id && <div className="form-error">{errors.escola_id}</div>}
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label required">Ano Escolar</label>
                    <select
                      className={`form-select ${errors.ano_escolar_id ? 'error' : ''}`}
                      value={formData.ano_escolar_id}
                      onChange={(e) => handleInputChange('ano_escolar_id', e.target.value)}
                    >
                      <option value="">Selecione o ano</option>
                      {anosEscolares.map(ano => (
                        <option key={ano.id} value={ano.id}>{ano.nome}</option>
                      ))}
                    </select>
                    {errors.ano_escolar_id && <div className="form-error">{errors.ano_escolar_id}</div>}
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label required">Período</label>
                    <select
                      className={`form-select ${errors.periodo ? 'error' : ''}`}
                      value={formData.periodo}
                      onChange={(e) => handleInputChange('periodo', e.target.value)}
                    >
                      <option value="">Selecione o período</option>
                      {periodos.map(periodo => (
                        <option key={periodo} value={periodo}>
                          {periodo.charAt(0).toUpperCase() + periodo.slice(1)}
                        </option>
                      ))}
                    </select>
                    {errors.periodo && <div className="form-error">{errors.periodo}</div>}
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label">RA (Registro Acadêmico)</label>
                    <input
                      type="text"
                      className="form-input"
                      value={formData.ra}
                      onChange={(e) => handleInputChange('ra', e.target.value)}
                      placeholder="Registro acadêmico"
                    />
                  </div>
                </div>
              </div>
              
              {/* Senha */}
              <div className="form-section">
                <h3 className="section-title">Acesso ao Sistema</h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label className={`form-label ${!editingAluno ? 'required' : ''}`}>
                      {editingAluno ? 'Nova Senha (deixe em branco para manter)' : 'Senha'}
                    </label>
                    <div className="password-input">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className={`form-input ${errors.senha ? 'error' : ''}`}
                        value={formData.senha}
                        onChange={(e) => handleInputChange('senha', e.target.value)}
                        placeholder="Digite a senha"
                      />
                      <button
                        type="button"
                        className="password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                      </button>
                    </div>
                    {errors.senha && <div className="form-error">{errors.senha}</div>}
                  </div>
                  
                  <div className="form-group">
                    <label className={`form-label ${!editingAluno ? 'required' : ''}`}>
                      Confirmar Senha
                    </label>
                    <div className="password-input">
                      <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        className={`form-input ${errors.confirmarSenha ? 'error' : ''}`}
                        value={formData.confirmarSenha}
                        onChange={(e) => handleInputChange('confirmarSenha', e.target.value)}
                        placeholder="Confirme a senha"
                      />
                      <button
                        type="button"
                        className="password-toggle"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      >
                        {showConfirmPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                      </button>
                    </div>
                    {errors.confirmarSenha && <div className="form-error">{errors.confirmarSenha}</div>}
                  </div>
                </div>
                
                {!editingAluno && (
                  <div className="checkbox-group">
                    <input
                      type="checkbox"
                      id="createAuthUser"
                      checked={createAuthUser}
                      onChange={(e) => setCreateAuthUser(e.target.checked)}
                    />
                    <label htmlFor="createAuthUser">
                      Criar usuário de acesso ao sistema
                    </label>
                  </div>
                )}
              </div>
              
              {/* Status */}
              <div className="form-section">
                <div className="checkbox-group">
                  <input
                    type="checkbox"
                    id="ativo"
                    checked={formData.ativo}
                    onChange={(e) => handleInputChange('ativo', e.target.checked)}
                  />
                  <label htmlFor="ativo">Aluno ativo</label>
                </div>
              </div>
            </div>
            
            <div className="modal-footer">
              <button className="btn-secondary" onClick={closeModal}>
                <X size={16} />
                Cancelar
              </button>
              <button 
                className="btn-primary" 
                onClick={handleSave}
                disabled={loading}
              >
                <Save size={16} />
                {editingAluno ? 'Atualizar' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Importação */}
      {showImportModal && (
        <ImportarAlunos 
          onClose={() => setShowImportModal(false)}
          onImportComplete={() => {
            loadData(); // Recarregar lista de alunos
            setShowImportModal(false);
          }}
        />
      )}
    </div>
  );
};

export default Alunos;
